module.exports = __webpack_public_path__ + "static/media/autochilango-logo.2241b764.svg";